import { useState, useEffect } from "react";
import styles from "../styles/LoginScreen.module.css";

export default function LoginScreen({ onLogin }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const organizationMapping = {
    K1: "71e43327-3370-4853-8fc9-a96197e9cab7",
    K2: "9e124283-c125-449e-bfa9-4401b04f17ce",
    K3: "c7a8d997-95b7-4f88-b26c-7a22e17dbc62",
    K4: "f451bc37-3934-4ed6-971f-7d4c0462a064",
    K5: "f5a722cd-6a2e-41bf-9e74-e452a297e7dc",
    K6: "553afc5a-1245-4403-b114-5528492c84e3",
    K7: "fc3c1a7c-fdcd-404e-a38d-7dbc55993e59",
    K8: "a49493b8-ce4f-42c7-ac12-4672703a8082",
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      onLogin(token);
    }
  }, [onLogin]);

  const handleLogin = async () => {
    setError("");

    if (!organizationMapping[code]) {
      setError("Неверный код кухни");
      return;
    }

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code }),
      });

      const data = await response.json();

      if (!data.success) {
        setError(data.message || "Ошибка входа. Проверьте код.");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("organizationCode", code);
      localStorage.setItem("organizationId", organizationMapping[code]);
      localStorage.setItem("adminCode", code);
      onLogin(data.token);
    } catch (err) {
      console.error("Ошибка входа:", err);
      setError("Ошибка сервера. Попробуйте позже.");
    }
  };

  return (
    <div className={styles.loginContainer}>
      <h2>Введите код кухни</h2>
      <input
        type="text"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        className={styles.input}
        placeholder="K1-K8"
      />
      <button onClick={handleLogin} className={styles.button}>
        Войти
      </button>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}
